import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Notification from '../../models/Notification';

interface NotificationProps {
  notification: Notification,
  handleClose: Function
};
class NotificationModal extends Component<NotificationProps> {
  state = {
    isOpen: false
  };

  static getDerivedStateFromProps(nextProps: NotificationProps) {
    return {
      isOpen: nextProps.notification.message? true : false,
    };
  }

  render() {
    return (
      <Dialog
        open={this.state.isOpen}
        onClose={() => { this.props.handleClose()}}
        aria-labelledby="notification-dialog-title"
      >
        <DialogTitle id="notification-dialog-title">{this.props.notification.type}</DialogTitle>
        <DialogContent>
          {this.props.notification.message}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {this.props.handleClose()}} color="primary" variant="contained">OK</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default NotificationModal;
